/* @flow */

import { call, put, takeEvery } from 'redux-saga/effects'

import type { FluxStandardAction } from '../../types'

import { sagaDelete } from '../../fetch'
import { API_BLACKLIST } from '../../urls'
import {
  BadResponseError,
  SagaMalfunctionError,
  sagaHandleError,
  ActionRequiresPropertyError,
  UnauthorizedError,
} from '../../helpers'

import { deleteUrlBlacklistStore } from '../../stores/automation/blacklistStore'
import { sagaLogoutUnauthorizedUser } from '../logout'

export const DELETE_BLACKLIST_URL: string = 'opinary/DELETE_BLACKLIST_URL'

export function deleteBlacklistUrl(id: number): FluxStandardAction {
  return {
    type: DELETE_BLACKLIST_URL,
    payload: {
      id,
    },
  }
}

export function* sagaDeleteBlacklistUrl(
  action: FluxStandardAction
): Generator<*, void, *> {
  if (!(action && action.payload && action.payload.id)) {
    throw new ActionRequiresPropertyError(
      DELETE_BLACKLIST_URL,
      'payload',
      'payload.id'
    )
  }
  try {
    const response = yield call(
      sagaDelete,
      `${API_BLACKLIST}/${action.payload.id}`
    )
    if (response == null) throw new SagaMalfunctionError()
    if (response.status === 401 || response.status === 403) {
      yield call(sagaLogoutUnauthorizedUser)
      throw new UnauthorizedError()
    }
    if (response.status !== 204) throw new BadResponseError(response)

    if (action && action.payload && action.payload.id) {
      yield put(deleteUrlBlacklistStore(action.payload.id))
    }
  } catch (err) {
    yield call(sagaHandleError, err)
  }
}

export function* sagaRepeatedlyDeleteBlacklistUrl(): Generator<*, void, *> {
  yield takeEvery(DELETE_BLACKLIST_URL, sagaDeleteBlacklistUrl)
}



// WEBPACK FOOTER //
// ./src/sagas/automation/deleteBlacklist.js